import React from "react";
import { useState, useEffect } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Api from "app/services/api";
import Path from "app/route/Path";
import Button from "app/components/common/Button";
import ExaminationData from "app/components/ExaminationData";

function ExaminationDataListPage() {
  const navigate = useNavigate();
  // Ricky : need to merge new code from NWS

  const [examinationDatas, setExaminationDatas] = useState([]);
  const [examinationDatasLoaded, setExaminationDatasLoaded] = useState(false);

  const [arriveBtnTxt, setArriveBtnTxt] = useState(false);

  useEffect(() => {
    async function getAllExaminationDatas() {
      const response = await Api.examinationDatas.all();
      const items = response.data;
      setExaminationDatas(items);
      setExaminationDatasLoaded(true);
    }

    getAllExaminationDatas();
  }, []);

  useEffect(() => {
    setArriveBtnTxt("到着");
  }, []);

  const registerButtonClicked = () => {
    navigate(Path.examination.create(0));
  };

  const exportButtonClicked = async () => {
    await Api.examinationDatas.exportApi().then((data) => {
      const csvDataFromServer = data.data;
      const blob = new Blob([csvDataFromServer], { type: "text/csv" });
      const csvURL = URL.createObjectURL(blob);
      const fileName = "csv-file";
      // create a element to get download
      const link = document.createElement("a");
      // set a element properties: href, download
      link.href = csvURL;
      link.setAttribute("download", `${fileName}.csv`);
      // add a element to DOM
      document.body.appendChild(link);
      link.click();
      // remove a element from DOM after finish
      document.body.removeChild(link);
    });
  };

  const exportScalpDataButtonClicked = () => {
    if (!examinationDatas || examinationDatas.length === 0) return;
    const sortedDatas = [...examinationDatas].sort((a, b) => {
      const salonNameA = a.salonName || "N/A";
      const salonNameB = b.salonName || "N/A";
      if (salonNameA < salonNameB) return -1;
      if (salonNameA > salonNameB) return 1;
      const customerNoA = a.customerNo || "";
      const customerNoB = b.customerNo || "";
      return customerNoA.localeCompare(customerNoB);
    });

    const columns = [
      { key: "salonName", label: "salonName" },
      { key: "customerNo", label: "customerNo" },
      { key: "customerName", label: "customerName" },
      { key: "rawCP", label: "rawCP" },
      { key: "rawCellArea", label: "rawCellArea" },
      { key: "rawPeeling", label: "rawPeeling" },
      { key: "factorCellArea", label: "factorCellArea" },
      { key: "factorCP", label: "factorCP" },
      { key: "factorPeeling", label: "factorPeeling" },
      { key: "factorCluster", label: "factorCluster" },
    ];

    const csvRows = [];
    csvRows.push(columns.map((col) => col.label).join(","));

    sortedDatas.forEach((obj) => {
      const row = columns.map((col) => {
        const val = obj[col.key];
        if (val === undefined || val === null) return "";
        if (
          typeof val === "string" &&
          (val.includes(",") || val.includes("\n"))
        ) {
          return `"${val.replace(/"/g, '""')}"`;
        }
        return val;
      });
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "scalp_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // 釋放 URL 資源
  };

  const onDetailClicked = (examinationData) => {
    navigate(Path.examination.detail(examinationData.id));
  };

  const onArrivedClicked = (examinationData) => {
    // update salonDeliverStatus for scalp data
    console.log("到着しました", examinationData);

    let payload = {
      // analyseStatus: values.analyseStatus,
      // factorCellArea: Number(values.cellArea),
      // factorCluster: Number(values.cluster),
      // factorCP: Number(values.cp),
      customerNo: examinationData.customerNo,
      inspectionKitId: examinationData.inspectionKitId,
      // factorScore: Number(values.overall),
      // factorPeeling: Number(values.peeling),
      // analyseDate: values.registerDate.toISOString(),
      // inspectionDate: examinationDataItem.inspectionDate,
      // name: examinationDataItem.name,
      salonDeliverStatus: "done",
    };

    Api.examinationDatas
      .updateSalonDeliverStatus({
        examinationDataId: examinationData.id,
        payload,
      })
      .then((res) => {
        async function getAllExaminationDatas() {
          const response = await Api.examinationDatas.all();
          const items = response.data;
          setExaminationDatas(items);
          setExaminationDatasLoaded(true);
        }

        getAllExaminationDatas();
        //gotoNextStep();
        //setIsSubmitting(false);
      })
      .catch((e) => {
        //setIsSubmitting(false);
        alert(e);
      })
      .finally(() => {
        //setIsSubmitting(false);
      });
  };

  const onDrcDeliverClicked = (examinationData) => {
    // update scalpLabDeliverStatus for scalp data
    console.log("到着しました", examinationData);

    let payload = {
      // analyseStatus: values.analyseStatus,
      // factorCellArea: Number(values.cellArea),
      // factorCluster: Number(values.cluster),
      // factorCP: Number(values.cp),
      customerNo: examinationData.customerNo,
      inspectionKitId: examinationData.inspectionKitId,
      // factorScore: Number(values.overall),
      // factorPeeling: Number(values.peeling),
      // analyseDate: values.registerDate.toISOString(),
      // inspectionDate: examinationDataItem.inspectionDate,
      // name: examinationDataItem.name,
      //salonDeliverStatus: "done",
      //orderDate: new Date(),
      scalpLabDeliverStatus: "pending",
    };

    console.log("payload ", payload);

    Api.examinationDatas
      .updateScalpLabDeliverStatus({
        examinationDataId: examinationData.id,
        payload,
      })
      .then((res) => {
        async function getAllExaminationDatas() {
          const response = await Api.examinationDatas.all();
          const items = response.data;
          setExaminationDatas(items);
          setExaminationDatasLoaded(true);
        }

        getAllExaminationDatas();
        //gotoNextStep();
        //setIsSubmitting(false);
      })
      .catch((e) => {
        //setIsSubmitting(false);
        alert(e);
      })
      .finally(() => {
        //setIsSubmitting(false);
      });
  };

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "検査データ",
      }}
    >
      {/* chen */}
      <Button.Primary
        onClick={() => {
          navigate(Path.examination.batchReceiveLab);
        }}
      >
        検体到着管理
      </Button.Primary>

      <Button.Primary
        onClick={() => {
          navigate(Path.examination.batchDeliverDrc);
        }}
      >
        検体発送
      </Button.Primary>

      {/* <Button.Secondary onClick={exportButtonClicked}>
        エクスポート
      </Button.Secondary> */}

      <Button.Secondary onClick={exportScalpDataButtonClicked}>
        検査データ エクスポート
      </Button.Secondary>

      <ExaminationData.Table.Table
        items={examinationDatas}
        loading={!examinationDatasLoaded}
      >
        <ExaminationData.Table.Loading>
          <tbody>
            <tr>
              <td colSpan="100">ローディング中</td>
            </tr>
          </tbody>
        </ExaminationData.Table.Loading>
        <ExaminationData.Table.Empty>
          検査データがないです。
        </ExaminationData.Table.Empty>
        <ExaminationData.Table.Header>
          <tr>
            {/* <th scope="col" className="px-6 py-4">
              -
            </th>
            <th scope="col" className="px-6 py-4">
              -
            </th> */}
            <th scope="col" className="px-6 py-4">
              お客様ID
            </th>
            <th scope="col" className="px-6 py-4">
              キットID
            </th>
            <th scope="col" className="px-6 py-4">
              クラスター
            </th>
            <th scope="col" className="px-6 py-4">
              細胞面積
            </th>
            <th scope="col" className="px-6 py-4">
              多重剥離
            </th>
            <th scope="col" className="px-6 py-4">
              CP
            </th>
            <th scope="col" className="px-6 py-4">
              総合
            </th>
            <th scope="col" className="px-6 py-4">
              登録日時
            </th>
            <th scope="col" className="px-6 py-4">
              分析状況
            </th>
            <th scope="col" className="px-6 py-4">
              詳細
            </th>
          </tr>
        </ExaminationData.Table.Header>
        <ExaminationData.Table.Items>
          {examinationDatas
            .filter((item) => item.salonDeliverStatus !== undefined) // 篩選具有 salonDeliverStatus 欄位的物件
            .map((item) => (
              <ExaminationData.Table.Item
                key={item.id + item?.salonName}
                onDetailClick={onDetailClicked}
                onArrivedClick={onArrivedClicked}
                onDrcDeliverClick={onDrcDeliverClicked}
                arriveBtnTxt={
                  item.salonDeliverStatus == "pending" ? "到着" : "到着した"
                }
                drcDeliverBtnTxt={
                  item.scalpLabDeliverStatus == "none"
                    ? "DRCに発送"
                    : "DRCに発送した"
                }
              >
                {item}
              </ExaminationData.Table.Item>
            ))}
        </ExaminationData.Table.Items>
      </ExaminationData.Table.Table>
    </DefaultLayout>
  );
}

export default ExaminationDataListPage;
